import { request, success, failure, EMPLOYEE_REQUEST } from './utilities';
import { blockOrUnblockEmployee, getSalaryEmployeeList } from '../api';

export function EmployeeListForSalary() {
    return (dispatch) => {
        dispatch(request(EMPLOYEE_REQUEST.GET_EMPLOYEE_REQUEST));
        getSalaryEmployeeList().then(
            response => {
                if (response.data) {
                    dispatch(success(EMPLOYEE_REQUEST.GET_EMPLOYEE_SUCCESS, response.data))
                }
                else {
                    dispatch(failure(EMPLOYEE_REQUEST.GET_EMPLOYEE_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(EMPLOYEE_REQUEST.GET_EMPLOYEE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}

export function BlockOrUnblockUser(userId) {
    return (dispatch) => {
        dispatch(request(EMPLOYEE_REQUEST.BLOCK_UNBLOCK_EMPLOYEE_REQUEST));
        dispatch(success(EMPLOYEE_REQUEST.BLOCK_UNBLOCK_EMPLOYEE_SUCCESS, userId))
        // blockOrUnblockEmployee(userId).then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(EMPLOYEE_REQUEST.BLOCK_UNBLOCK_EMPLOYEE_SUCCESS, response.data.data))
        //         }
        //         else {
        //             dispatch(failure(EMPLOYEE_REQUEST.BLOCK_UNBLOCK_EMPLOYEE_FAILURE, response.data.message))
        //         }
        //     },
        //     error=>{
        //         dispatch(failure(EMPLOYEE_REQUEST.BLOCK_UNBLOCK_EMPLOYEE_FAILURE,(error&&error.response&&error.response.data&&error.response.data.title)?error.response.data.title:error.message))
        //     }
        //)
    }
}